module.exports = __webpack_public_path__ + "img/window-frame-open.3c0eb8a1.svg";